import { render, staticRenderFns } from "./MoreDetails.vue?vue&type=template&id=0a07553d&scoped=true&"
import script from "./MoreDetails.vue?vue&type=script&lang=js&"
export * from "./MoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoreDetails.vue?vue&type=style&index=0&id=0a07553d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a07553d",
  null
  
)

export default component.exports